export default {
  setTerm: (state, term) => {
    state.term = term
  },
  setCourses: (state, courses) => {
    state.courses = courses
  },
  setSupervisors: (state, supervisors) => {
    state.supervisors = supervisors
  },
  setFilter: (state, { area, course, supervisor }) => {
    if (area) state.filter.area = area
    if (course) state.filter.course = course
    if (supervisor) state.filter.supervisor = supervisor
  },
  setCourseFilter: (state, courses) => {
    state.courseFilter = courses
  },
  setSuperFilter: (state, supers) => {
    state.superFilter = supers
  }
}
